import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type {
  AddWishlistItem,
  RemoveWishlistItem,
} from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const ADD_WISHLIST_ITEM = 'add_wishlist_item'

export const triggerAddWishlistItemEvent = (event: AddWishlistItem) => {
  triggerEvent(ADD_WISHLIST_ITEM, event)
}

export const onAddWishlistItemEvent = (
  callback: EventCallback<AddWishlistItem>
) => subscribeEvent(ADD_WISHLIST_ITEM, callback)

export const removeAddWishlistItemEvent = (
  token: EventToken<AddWishlistItem>
) => unsubscribeEvent(ADD_WISHLIST_ITEM, token)

const REMOVE_WISHLIST_ITEM = 'remove_wishlist_item'

export const triggerRemoveWishlistItemEvent = (event: RemoveWishlistItem) => {
  triggerEvent(REMOVE_WISHLIST_ITEM, event)
}

export const onRemoveWishlistItemEvent = (
  callback: EventCallback<RemoveWishlistItem>
) => subscribeEvent(REMOVE_WISHLIST_ITEM, callback)

export const removeRemoveWishlistItemEvent = (
  token: EventToken<RemoveWishlistItem>
) => unsubscribeEvent(REMOVE_WISHLIST_ITEM, token)
